import { type CardsModel } from '../../types'
import { type TCards } from '../../../redux/types/CardsTypes'

const mapCards = (cards: TCards[] | undefined): CardsModel[] | undefined => {
  return cards?.map((card: any) => {
    const limit = (card.total_limit + '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    const dailyLimit = (card.daily_total_limit + '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    const monthlyLimit = (card.monthly_total_limit + '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    const paymentType = Array.isArray(card.payment_type) ? card.payment_type.join(',') : card.payment_type
    return {
      ...card,
      payment_type: paymentType,
      total_limit: limit,
      daily_total_limit: dailyLimit,
      monthly_total_limit: monthlyLimit,
    }
  })
}

export default mapCards
